"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportTranscriptToText = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var exportTranscriptToText = function exportTranscriptToText(_ref) {
  var _metaData$detail, _metaData$detail$call, _metaData$detail$call2, _metaData$detail2;

  var _ref$metaData = _ref.metaData,
      metaData = _ref$metaData === void 0 ? {} : _ref$metaData,
      exportTranscript = _ref.exportTranscript,
      isHostedApp = _ref.isHostedApp;
  var transcriptBody = document.querySelector(".transcript-body");
  var s = new XMLSerializer();
  var str = s.serializeToString(transcriptBody);
  var formattedText2 = str; // Replace first turn div found with empty string and subsequent turn divs with new line

  formattedText2 = formattedText2.replace(/<div class="turn-p[^<]*>/, "");
  formattedText2 = formattedText2.replace(/<div class="turn-p[^<]*>/gi, "\n"); // Replace first chat/messaging turn div with empty string and subsequent chat/messaging turn divs with new line

  formattedText2 = formattedText2.replace(/<div class="transcript-turn[^<]*>/, "");
  formattedText2 = formattedText2.replace(/<div class="transcript-turn[^<]*>/gi, "\n"); // Replace all closing </a> tags with new line

  formattedText2 = formattedText2.replace(/<\/a>/gi, "\n"); // Replace all <div> tags with empty string

  formattedText2 = formattedText2.replace(/<div[^<]*>/gi, ""); // Replace all closing </div> tags with empty string

  formattedText2 = formattedText2.replace(/<\/div>/gi, ""); // Replace all remaining tags with empty string

  formattedText2 = formattedText2.replace(/<[^>]+>/gi, "");
  var encodedUri = encodeURIComponent(formattedText2);
  var agentName = (metaData === null || metaData === void 0 ? void 0 : (_metaData$detail = metaData.detail) === null || _metaData$detail === void 0 ? void 0 : (_metaData$detail$call = _metaData$detail.callDetails) === null || _metaData$detail$call === void 0 ? void 0 : (_metaData$detail$call2 = _metaData$detail$call.agent) === null || _metaData$detail$call2 === void 0 ? void 0 : _metaData$detail$call2.fullName) || "No agent details";
  var callStartTime = ((metaData === null || metaData === void 0 ? void 0 : (_metaData$detail2 = metaData.detail) === null || _metaData$detail2 === void 0 ? void 0 : _metaData$detail2.parsedDate) || (0, _dayjs["default"])(new Date()).format("MMM DD, YYYY, hh:mm:ss A")).replace(/:/g, "");
  var element = document.createElement("a");
  element.style.display = "none";
  element.setAttribute("href", "data:text/plain;charset=utf-8," + encodedUri);
  element.setAttribute("download", agentName + "_" + callStartTime + ".txt");
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);

  if (!isHostedApp) {
    exportTranscript(encodedUri);
  }
};

exports.exportTranscriptToText = exportTranscriptToText;